import React from "react"
import Typography from "../../../../../../ui/atoms/Typography"
import { formatMoney } from "../../../../../../utils/money"
import { useLabels } from "../../../../../contents/hooks"
import { Basket } from "../../../../state/checkoutTypes"

interface Props {
  basket: Basket
}

const ShippingLabel = ({ basket }: Props) => {
  const { getLabel } = useLabels()

  if (basket.shipping?.free) {
    return (
      <Typography variant="body1">
        {getLabel("basket", "free-shipping-default")}
      </Typography>
    )
  }

  if (basket.shipping.hasFreeShippingPromo) {
    return (
      <Typography variant="body1">
        {getLabel("basket", "free-shipping-promo")}
      </Typography>
    )
  }

  return (
    <Typography variant="body1">
      {getLabel("basket", "free-shipping-left-prefix")}{" "}
      <strong>
        {formatMoney({
          amount: basket.shipping?.freeShippingAmountLeft,
          currency: "eur",
          currencyPosition: "after",
        })}
      </strong>{" "}
      {getLabel("basket", "free-shipping-left-suffix")}
    </Typography>
  )
}

export default ShippingLabel
